module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_1-41825e9856c56db1d861ab3263c74c7f.png";